import { fetchWithCSRF } from '../utils/csrfUtils';
import { useAuth } from '../context/AuthContext';
import useRefreshGroceryListIngredientQuantity from './refreshGroceryListIngredientQuantity';
import { getTodayLocalDateString, getDateWithOffset } from '../utils/dateUtils';

const useUpdateRelevantGroceryListIngredientsOnPantryIngredientCRUD = () => {
    const { refreshGroceryListIngredientQuantity } = useRefreshGroceryListIngredientQuantity();
    const { sessionToken } = useAuth();

    const updateGroceryLists = async (ingredientId, appUserId, onGroceryListUpdate) => {
        try {
            if (!sessionToken) {
                throw new Error('No valid session found');
            }

            const todaysBrowserDate = getTodayLocalDateString(); //YYYY-MM-DD
            const nextWeekBrowserDate = getDateWithOffset(7); //YYYY-MM-DD

            const response = await fetchWithCSRF('/api/v1/pantry-ingredient/refresh_grocery_list_ingredients_on_pantry_ingredient_crud', {
                method: 'POST',
                body: JSON.stringify({ ingredientId, appUserId, todaysBrowserDate, nextWeekBrowserDate }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log("hook result data: ", result);

            if (result.thisWeekGroceryListIngredientsRefreshed?.groceryListIngredientRefreshed) {
                onGroceryListUpdate('This week\'s grocery list has been updated');
            }
            if (result.nextWeekGroceryListIngredientsRefreshed?.groceryListIngredientRefreshed) {
                onGroceryListUpdate('Next week\'s grocery list has been updated');
            }

            return true;
        } catch (error) {
            console.error('Error updating grocery lists:', error);
            return false;
        }
    };

    return { updateGroceryLists };
};

export default useUpdateRelevantGroceryListIngredientsOnPantryIngredientCRUD;